import BaseModel from "@/app/base/BaseModel";
import UserProfileModel from "./UserProfileModel";

export default class AccountModel extends BaseModel {
    constructor(props) {
        super(props)
        this.id = null
        this.mail = ''
        this.approval = null
        this.password = ''
        this.register_datetime = ''
        this.cws_channel = ''
        this.paid = false
        this.profile = {}
        this.syncProps(props)
    }

    get fullName() {
        return `${this.firstName} ${this.lastName}`
    }

    // syncProps(props) {
    //     if (props && _.isObject(props) && ('profile' in props) && props.profile.length) {
    //         props.profile.map(item => new UserProfileModel(item))
    //     }
    //
    //     return super.syncProps(props);
    // }

    rawValue() {
        const val = super.rawValue();
        if (val.role_id) {
            val.role_id = val.role_id.id
        }
        if (val.customer)
            val.customer = val.customer._id

        return val
    }

    rawValueUserGroupRole() {
        const val = super.rawValue();
        if (val.customer)
            val.customer = val.customer._id

        return val
    }
}

AccountModel.STATUS = {
    0: '未公開',
    1: '公開',
    2: '業務進行中',
    3: '完了',
};

AccountModel.WORKERSTATUS = {
    0: 'エントリー中',
    1: '確定',
    2: '終了',
};

